<template>
  <div class="card shadow-sm">
    <br>
    <div class="card-body">

      <div class="row g-3 align-items-end">
        <!-- Código elemento -->
        <div class="col-12 col-md-4">
          <label class="form-label fw-bold">Código Elemento</label>
          <input
            type="text"
            class="form-control"
            v-model.trim="form.codigo"
            placeholder="Ej: 36581"
            :class="{ 'is-invalid': errores.codigo }"
          />
          <div class="invalid-feedback">{{ errores.codigo }}</div>
        </div>

        <!-- Valor -->
        <div class="col-12 col-md-3">
          <label class="form-label fw-bold">Valor</label>
          <input
            type="number"
            step="0.01"
            min="0"
            class="form-control"
            v-model.number="form.valor"
            placeholder="Ej: 31.33"
            :class="{ 'is-invalid': errores.valor }"
          />
          <div class="invalid-feedback">{{ errores.valor }}</div>
        </div>

        <!-- Botón -->
        <div class="col-12 col-md-2">
          <button
            class="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-1"
            @click="guardar"
            :disabled="cargando"
          >
            <span v-if="cargando" class="spinner-border spinner-border-sm"></span>
            <span v-else class="material-icons" style="font-size:18px">save</span>
            {{ cargando ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </div>

      <!-- Resultado -->
      <div v-if="mensaje" class="mt-3 alert" :class="mensajeClase">
        {{ mensaje }}
      </div>

    </div>
  </div>
</template>

<script>
import api  from "@/services/api";
import Swal from "sweetalert2";

export default {
  name: "TarifaPresForm",
  props: {
    p_idPrestador: { type: Number, required: true },
  },
  data() {
    return {
      form: {
        codigo: "",
        valor:  null,
      },
      errores:   {},
      cargando:  false,
      mensaje:   "",
      mensajeClase: "",
    };
  },
  methods: {
    validar() {
      this.errores = {};
      if (!this.form.codigo)
        this.errores.codigo = "El código es obligatorio.";
      if (this.form.valor === null || this.form.valor === "")
        this.errores.valor = "El valor es obligatorio.";
      else if (this.form.valor < 0)
        this.errores.valor = "El valor no puede ser negativo.";
      return Object.keys(this.errores).length === 0;
    },

async guardar() {
  if (!this.validar()) return;
  this.cargando = true;
  this.mensaje  = "";
  try {
    const response = await api.post("/procedimientos/insertar-tarifa-pres", null, {
      params: {
        idPrestador: this.p_idPrestador,
        codigo:      this.form.codigo,
        valor:       this.form.valor,
      },
    });
    const { insertados, actualizados, mensaje } = response.data;

    if (actualizados > 0) {
      this.mensajeClase = "alert-warning";   // amarillo = actualización
      this.mensaje      = `✎ ${mensaje} (${actualizados})`;
    } else {
      this.mensajeClase = "alert-success";   // verde = nuevo registro
      this.mensaje      = `✓ ${mensaje} (${insertados})`;
    }
    this.form.codigo  = "";
    this.form.valor   = null;
    setTimeout(() => { this.mensaje = ""; }, 4000);
  } catch (error) {
    const msg =
      typeof error.response?.data === "string"
        ? error.response.data
        : error.response?.data?.message
        ?? error.response?.data?.error
        ?? error.message
        ?? "Error desconocido";
    this.mensaje      = msg;
    this.mensajeClase = "alert-danger";
    Swal.fire({ icon: "error", title: "Error", text: msg });
  } finally {
    this.cargando = false;
  }
},
  },
};
</script>